import React from 'react';

import CardFrame from '../common/CardFrame';
import EventInfoRow from './EventInfoRow';

import Logos from '../Logo/Logos';
import {useRecordContext} from 'components/record/useRecordContext';
import {Info} from '@mui/icons-material';
import EditButton from 'components/forms/EditButton';
import EventSettingsForm from './EventSettingsForm';

const EventSettings = () => {
  const {record} = useRecordContext();

  return (
    <React.Fragment>
      <CardFrame
        title="Event Settings"
        avatar={<Info />}
        action={
          <EditButton>
            <EventSettingsForm />
          </EditButton>
        }
      >
        <EventInfoRow title="Can Enter" source={record.canEnter ? 'true' : ''} />
        <EventInfoRow title="Auto Accept Entries" source={record.autoAcceptEntry ? 'true' : ''} />
        <EventInfoRow title="Auto create competitors from activities" source={record.autoCreateCompetitorsFromActivity ? 'true' : ''} />
        <EventInfoRow title="Analytic" source={record.analytic ? 'true' : ''} />
        <EventInfoRow title="Alt Event Settings" source={record.altEventSettings ? 'true' : ''} />
        {/* <EventInfoRow title="GPS Interval" source={record.gpsInterval} /> */}
        <EventInfoRow title="Delay" source={record.delay} />
        <EventInfoRow title="Marker Type" source={record.markerType} />
        <EventInfoRow title="Use SportIdent" source={record.useSI} />
        <EventInfoRow title="Use Results" source={record.useResults ? 'true' : ''} />
        {record.useResults && <EventInfoRow title="Live Results CompetitionId" source={record.liveResultsCompetitionId} />}
      </CardFrame>
      <Logos />
    </React.Fragment>
  );
};
export default EventSettings;
